import { api } from './'

export const getTokenTemporal = async (tokenTemporal: string) => {
  return await api.get('/api/tokenTemporal', {
    params: {
      tokenTemporal
    }
  })
}